import { ReactSortable } from "react-sortablejs";
import { Bars3Icon } from "@";

const Sortable = ({ data, set, order }) => {
  const handleSort = () => {
    const sortedData = data.map((item, index) => ({
      ...item,
      order: index,
    }));
    order(sortedData);
  };

  return (
    <ReactSortable list={data} setList={set} onChange={handleSort}>
      {data.map((item) => (
        <div
          className="group mx-auto mb-3 flex cursor-move items-center gap-3 rounded-2xl border border-gray-100 bg-white p-3 text-base text-gray-700 shadow-sm shadow-gray-900/[0.03] transition-all duration-200 hover:-translate-y-0.5 hover:border-purple-200 hover:bg-purple-50/30 hover:shadow-md hover:shadow-purple-900/10 dark:border-gray-700/60 dark:bg-gray-800 dark:text-gray-300 dark:hover:border-purple-700 dark:hover:bg-gray-800/80 md:w-72"
          key={item.id}
        >
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray-50 text-gray-400 ring-1 ring-gray-100 transition-colors group-hover:bg-purple-100 group-hover:text-purple-700 group-hover:ring-purple-200 dark:bg-gray-700 dark:text-gray-500 dark:ring-gray-600 dark:group-hover:bg-purple-900/40 dark:group-hover:text-purple-300">
            <Bars3Icon className="h-4 w-4" />
          </span>
          <span className="flex-1 font-medium tracking-tight">
            {item.title}
          </span>
        </div>
      ))}
    </ReactSortable>
  );
};

export default Sortable;
